import { type FC, useCallback } from "react";

import { TagIcon } from "@snapchat/snap-design-system-icons";
import { useIntl } from "react-intl";

import { type Discoverability } from "../../../gql-generated/types";
import { LensDiscoverabilityModal } from "../../../lens-discoverability/components";
import { makeLensDiscoverabilityInput, useSetDiscoverability } from "../../../lens-discoverability/hooks";
import { useToggleState } from "../../../shared/hooks";

import { SidebarPanel } from "./SidebarPanel";
import { LensDiscoverabilityDescription, LensDiscoverabilityTooltip, messages } from "./messages.generated";

interface LensDiscoverabilityTagsSidebarPanel {
    lensId: string;
    discoverability: Discoverability | null;
}
export const LensDiscoverabilityTagsSidebarPanel: FC<LensDiscoverabilityTagsSidebarPanel> = ({
    lensId,
    discoverability,
}) => {
    const intl = useIntl();
    const [{ visible, onCancel }, showModal] = useToggleState();
    const { setDiscoverability, loading } = useSetDiscoverability();
    const onSave = useCallback(
        (discoverability: Discoverability) => {
            void setDiscoverability(makeLensDiscoverabilityInput(discoverability)).then(() => {
                onCancel();
            });
        },
        [onCancel, setDiscoverability],
    );
    return (
        <>
            <SidebarPanel
                dataTestIdPrefix="discoverability"
                label={intl.formatMessage(messages.lensDiscoverabilityLabel)}
                description={<LensDiscoverabilityDescription />}
                actionLabel={intl.formatMessage(messages.lensDiscoverabilityActionLabel)}
                tooltipContent={<LensDiscoverabilityTooltip />}
                Icon={TagIcon}
                showModal={showModal}
                disabled={false}
            />
            <LensDiscoverabilityModal
                lensOrSubmissionId={lensId}
                discoverability={discoverability}
                visible={visible}
                onSave={onSave}
                saveLoading={loading}
                onCancel={onCancel}
            />
        </>
    );
};
